import { area } from './area';
import { comun } from './comun';
import { contacto } from './contacto';
import { demo } from './demo';
import { legal } from './legal';
import { marketing } from './marketing';
import { meta } from './meta';

/**
 * Diccionario español, y **fuente de verdad del tipo `Mensajes`**.
 *
 * De aquí sale la forma que todos los demás idiomas tienen que cumplir, así que
 * una clave nueva se agrega primero en español: en cuanto se agrega, TypeScript
 * empieza a exigirla en los otros diccionarios y el build falla hasta que estén
 * completos. Ese es el mecanismo que evita publicar una pantalla a medio
 * traducir.
 */
export const es = {
  area,
  comun,
  contacto,
  demo,
  legal,
  marketing,
  meta,
};
